/** The Firebase app for analytics and messaging, created on first use (the SDK is a lazy chunk). */
import type { FirebaseApp } from "firebase/app";
import { firebaseOptions } from "./config.ts";

let app: Promise<FirebaseApp> | undefined;

export function firebaseApp(): Promise<FirebaseApp> {
  app ??= import("firebase/app").then(({ initializeApp }) => initializeApp(firebaseOptions));
  return app;
}
